import React, { useEffect , useState } from "react";
import "../Styles/Footer.css";
import "../Styles/Theme.css";
import footerLogo from "../assets/logo/ambrella-footer.png";
import { Link } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import config from "../config";
import Policy from "../RedirectingPages/FooterPages/Policy";
const Footer = () => {
    const [showPolicy, setShowPolicy] = useState(false);
  const toggleContact = () => {
    scroll.scrollToTop(0, 0);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <footer className="heading-bg" style={{ backgroundColor: "#01536E " }}>
        <div className="bd-footer-area pt-60 pb-10">
          <div className="container" style={{ maxWidth: "1270px" }}>
            <div className="row footer-column justify-content-center justify-content-around">
              <div className="col-lg-4 col-sm-6 column-first">
                <div className="bd-footer-widget footer-col-1">
                  <div className="bd-footer-info">
                    <div className="bd-footer-info-logo mb-20">
                      <Link to={`${config.appurl}`}>
                        <img
                          src={footerLogo}
                          style={{ width: "220px" , position:"relative"  , top:"20px" }}
                          className="img-fluid"
                          alt="img not found"
                        />
                      </Link>
                      {/* "https://res.cloudinary.com/ztpl-images/image/upload/q_auto,f_auto,fl_lossy/v1659376853/website/logo/zithas-main-logo_saitcj.png" */}
                    </div>
                    <div style={{ paddingLeft: "1px" }} className="d-flex">
                      {/* <div>
                        <h5
                          style={{
                            color: "white",
                            fontWeight: "400",
                            fontSize: "16px",
                            marginTop: "1px",
                            marginRight: "5px",
                          }}
                        >
                          {" "}
                          Stay Connected :
                        </h5>
                      </div> */}
                      <div className="bd-header-social text-center mb-50">
                        {/* <a
                          href="#"
                          target="_blank"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                        <a
                          href="#"
                          target="_blank"
                        >
                          <i className="fa-brands fa-x-twitter"></i>
                        </a>
                        <a
                          href="#"
                          target="_blank"
                        >
                          <i className="fab fa-instagram"></i>
                        </a> */}
                        {/* <a
                          href="https://www.linkedin.com/company/ambrella-consulting/"
                          target="_blank"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a> */}
                        {/* <a
                          href="#"
                          target="_blank"
                        >
                          <i className="fab fa-pinterest"></i>
                        </a>
                        <a
                          href="#"
                          target="_blank"
                        >
                          <i className="fab fa-youtube"></i>
                        </a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

           <div className="col-lg-4 col-sm-6 column-second text-white">
  <div
    className="bd-footer-widget footer-col-2 mb-30"
    style={{ paddingLeft: "0px" }}
  >
    <h5 className="bd-footer-widget-title mb-35">Quick Links</h5>
    <ul>
      <li>
        <Link to={`${config.appurl}services`} onClick={toggleContact} style={{ color: "white" }}>
          Services
        </Link>
      </li>
      <li>
        <Link to={`${config.appurl}competencies`} onClick={toggleContact} style={{ color: "white" }}>
          Competencies
        </Link>
      </li>
      {/* <li>
        <Link to={`${config.appurl}case-studies`} onClick={toggleContact} style={{ color: "white" }}>
          Case Studies
        </Link>
      </li> */}
      <li>
        <Link to={`${config.appurl}about-us`} onClick={toggleContact} style={{ color: "white" }}>
          About Us
        </Link>
      </li>
      <li>
        <Link to={`${config.appurl}contact-us`} onClick={toggleContact} style={{ color: "white" }}>
          Contact Us
        </Link>
      </li>
                    <li>
                      {/* Instead of route → open modal */}
                      <button 
                        className="btn btn-link p-0" 
                        style={{ color: "white", textDecoration: "none" }} 
                        onClick={() => setShowPolicy(true)}
                      >
                        Privacy Policy
                      </button>
                    </li>

      {/* <li>
        <Link to={"/career"}>Career</Link>
      </li> */}

      {/* <li>
        <Link
          to={"/testimonials"}
          onClick={toggleContact}
          spy="true"
          smooth="true"
          exact="true"
          style={{ color: "white" }}
        >
          Testimonials
        </Link>
      </li> */}
    </ul>
  </div>
</div>


           <div className="col-lg-4 col-sm-6 column-second text-white pr-70">
  <div
    className="bd-footer-widget footer-col-2 mb-30"
    style={{ paddingLeft: "0px" }}
  >
    <h5 className="bd-footer-widget-title mb-35">Follow Us</h5>
    <ul>
      <li>
                        <a
                          href="https://www.linkedin.com/company/ambrella-consulting/"
                          target="_blank"
                          style={{color:"white"}}
                        >
                          Linkedin
                        </a>
      </li>
    </ul><br/>
        <div className="bd-footer-info-item mb-10">
                    <h5 className="bd-footer-widget-title mb-35">Contact Us</h5>
                    {/* <h6>Phone : </h6>
                    <a href="tel:+6587852030">+65 87852030</a> */}
                  </div>
                  <div className="bd-footer-info-item mb-10">
                     {/* <h6>Phone : </h6>
                    <a href="tel:+6587852030" className="text-white">+65 87852030</a><br/> */}
                    <h6>Email : </h6>
                    <a href="contact@ambrellaconsulting.com" style={{color:"white"}}>
                      contact@ambrellaconsulting.com
                    </a>
                  </div>
  </div>
</div>





              {/* <div className="col-lg-4 col-sm-6 column-third">
                <div
                  className="bd-footer-widget footer-col-3 mb-30"
                  style={{ paddingLeft: "0px" }}
                >
                  <h5 className="bd-footer-widget-title mb-35">
                    More Information
                  </h5>
                  <ul>

                    <li>
                      <Link
                        to={"/blog"}
                        onClick={toggleContact}
                        spy="true"
                        smooth="true"
                        exact="true"
                      >
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link to={"/privacy-policy"} onClick={toggleContact}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to={"/hire-a-resource"} onClick={toggleContact}>
                        {" "}
                        Hire A Resource
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
              {/* <div className="col-lg-3 col-sm-6 column-fourth">
                <div
                  className="bd-footer-widget footer-col-3 mb-30"
                  style={{ paddingLeft: "0px" }}
                >
                  <h5 className="bd-footer-widget-title mb-35">
                    Other Services
                  </h5>
                  <ul>
                    <li>
                      <Link to="/domain-consultancy">Domain Consultancy</Link>
                    </li>
                    <li>
                      <Link to="/it-engineering">IT Engineering</Link>
                    </li>
                  </ul>
                </div>
              </div> */}
              <div className="col-lg-4 col-sm-6 column-fifth">
                <div className="bd-footer-widget footer-col-4 mb-30">
                  <div className="bd-footer-info-item mb-10">
                    <h5 className="bd-footer-widget-title mb-35">Our Office Locations</h5>
                    {/* <h6>Phone : </h6>
                    <a href="tel:+6587852030">+65 87852030</a> */}
                  </div>
                  {/* <div className="bd-footer-info-item mb-10">
                    <h6>Email : </h6>
                    <a href="mailto:info@ambrellaconsulting.com" style={{color:"white"}}>
                      info@ambrellaconsulting.com
                    </a>
                  </div> */}
                  {/* <div className="bd-footer-info-item mb-10">
                    <h6>Location : </h6>
                  </div> */}
                  <div className="bd-footer-info-item mb-10 ">
                    {/* <h6>Location :</h6>
                    <h6>Singapore</h6> */}
     <div className="pt-4">
  <h6>Singapore</h6>
  <div className="address" style={{ height: "100px", width: "100%" }}>
    <iframe
      title="Singapore Office Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15955.04854129793!2d103.86135615!3d1.3261236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1abfd6c2d4c3%3A0x97e90b8bfae9bb5a!2s8%20Boon%20Keng%20Rd%2C%20Singapore%20330008!5e0!3m2!1sen!2ssg!4v1694600000000!5m2!1sen!2ssg"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
    ></iframe>
  </div>
</div>
 <div className="pt-30">
  <h6>Dubai</h6>
  <div className="address" style={{ height: "100px", width: "100%" }}>
    <iframe
      title="Dubai Office Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.4876608875427!2d55.22605631500813!3d25.145365983956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5c302a17f1f7%3A0xbed3142a9de1e9a5!2s3-A86%2C%20Bin%20Dasmal%20Building%2C%20Al%20Quoz%20Industrial%20Area%201%2C%20Dubai!5e0!3m2!1sen!2sae!4v1694600000000!5m2!1sen!2sae"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
    ></iframe>
  </div>
</div>
<div className="pt-4">
  <h6>India</h6>
  <div className="address" style={{ height: "100px", width: "100%" }}>
    <iframe
      title="Vadodara Office Location"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.756218695273!2d73.1812181!3d22.2973289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc8f8f4e54b3d%3A0xb3f5489de2f0dc3f!2sVadodara%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1696000000000!5m2!1sen!2sin"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bd-copyright-area">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="bd-copyright text-center">
                  <p className="m-0" style={{color:"white"}}>
                    © {new Date().getFullYear()} All rights reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
              {/* Privacy Policy Modal */}
      <Policy show={showPolicy} handleClose={() => setShowPolicy(false)} />
      </footer>
    </div>
  );
};

export default Footer;
